import { APP_INITIALIZER, inject, isDevMode, Provider } from '@angular/core';
import { filter, take, tap } from 'rxjs';

import { FeatureToggleService } from '../feature-toggle/feature-toggle.service';
import { GoogleAnalyticsService } from './google-analytics.service';

export function provideGoogleAnalytics(googleTagId: string | undefined): Provider[] {
  return googleTagId
    ? [
      {
        multi: true,
        provide: APP_INITIALIZER,
        useFactory: () => {
          const featureToggleService = inject(FeatureToggleService);
          const googleAnalyticsService = inject(GoogleAnalyticsService);

          return () => featureToggleService.initialized$.pipe(
            filter((initialized) => initialized),
            tap(() => {
              if (featureToggleService.isEnabled('fvdr-altair-ga-enabled') && !isDevMode()) {
                googleAnalyticsService.initialize(googleTagId);
              }
            }),
            take(1),
          );
        },
      },
    ]
    : [];
}